import React from 'react';
import './Forex.css';
import icon1 from '../../../assets/IconsTrusted-by-traders-across-Dubai.png';
import icon2 from '../../../assets/IconsTransparent-fees-&-real-time-market-access.png';
import icon3 from '../../../assets/IconsFully-secure-platform.png';
import icon4 from '../../../assets/Icons-Backed-by-professional-support.png';

const translations = {
    en: {
        heroSubtitle: "The currency market never sleeps—Neither do we",
        heroTitle: "Make every currency fluctuation count with GivTrade",
        heroHighlight: "GivTrade",
        heroDescription: "Join the growing wave of Dubai forex traders who trust us for speed, reliability, and transparency.",
        buttonText: "Start forex trading now",
        section2Title: "The market moves non-stop. Take control and turn those fluctuations into real profits.",
        section2Desc: "GivTrade lets you access the $6.6 trillion daily forex market—securely and effortlessly. Trade major, minor, and exotic currency pairs with low spreads, 24/7 support, and fast deposits & withdrawals.",
        whyTitle: "Why trade Forex with GivTrade?",
        benefits: [
            { title: "Spreads starting at 0.0 Pip", desc: "Get the most out of every trade with tighter spreads." },
            { title: "Fast & Safe Deposits and Withdrawals", desc: "No delays, no worries—your funds are always within reach." },
            { title: "Easy Account Opening", desc: "Get started in minutes." },
            { title: "24/7 Support", desc: "Support whenever you need it—24/7, we’re here for you." },
            { title: "Competitive Commissions", desc: "Get the most out of every trade with minimal costs." },
            { title: "Trade from Anywhere, Anytime", desc: "Trade forex on your terms, from your phone or desktop with GivTrade." },
        ],
        ctaTitle: "Get started",
        ctaDesc: "Open your account instantly.",
        ctaBenefits: [
            "Trusted by traders across Dubai",
            "Fully secure platform",
            "Transparent fees & real-time market access",
            "Backed by professional support",
        ],
        ctaBtn: "Open Your Account",
    },
    ar: {
        heroSubtitle: "سوق العملات لا ينام — ونحن كذلك",
        heroTitle: "حوّل كل تقلب في العملات إلى فرصة مع GivTrade",
        heroHighlight: "GivTrade",
        heroDescription: "انضم إلى الموجة المتزايدة من المتداولين في دبي الذين يثقون بنا للسرعة والشفافية والموثوقية.",
        buttonText: "ابدأ التداول الآن",
        section2Title: "السوق يتحرك باستمرار. سيطر على تلك التقلبات وحوّلها إلى أرباح حقيقية.",
        section2Desc: "يتيح لك GivTrade الوصول إلى سوق الفوركس الذي يتداول يوميًا بـ6.6 تريليون دولار — بأمان وسهولة. تداول أزواج العملات الرئيسية والثانوية والنادرة مع سبريد منخفض ودعم 24/7 وإيداعات وسحوبات سريعة.",
        whyTitle: "لماذا تتداول الفوركس مع GivTrade؟",
        benefits: [
            { title: "سبريد يبدأ من 0.0 نقطة", desc: "حقق أقصى استفادة من كل صفقة مع سبريد أكثر ضيقًا." },
            { title: "إيداعات وسحوبات سريعة وآمنة", desc: "بدون تأخير — أموالك دائمًا تحت تصرفك." },
            { title: "فتح حساب بسهولة", desc: "ابدأ في دقائق معدودة." },
            { title: "دعم 24/7", desc: "دعم متوفر لك في أي وقت — على مدار الساعة طوال أيام الأسبوع." },
            { title: "عمولات تنافسية", desc: "استفد إلى أقصى حد مع تكاليف منخفضة." },
            { title: "تداول من أي مكان وفي أي وقت", desc: "تداول الفوركس كما تريد من هاتفك أو حاسوبك مع GivTrade." },
        ],
        ctaTitle: "ابدأ الآن",
        ctaDesc: "افتح حسابك فوراً.",
        ctaBenefits: [
            "موثوق من قبل المتداولين في دبي",
            "منصة آمنة بالكامل",
            "رسوم شفافة ووصول مباشر للسوق",
            "مدعوم بدعم احترافي",
        ],
        ctaBtn: "افتح حسابك",
    }
};

const Forex = ({ language = 'en' }) => {
    const t = translations[language];

    return (
        <div className='full'>
            <div className='forex-container font-sans text-white'>
                {/* HERO SECTION */}
                <div className="hero-section-forex">
                    <div className="hero-overlay" />
                    <div className="hero-content">
                        <p className="hero-subtitle">{t.heroSubtitle}</p>
                        <h1 className="hero-title">
                            {t.heroTitle.split('GivTrade')[0]}
                            <span className="highlight">{t.heroHighlight}</span>
                            {t.heroTitle.split('GivTrade')[1]}
                        </h1>
                        <p className="hero-description">{t.heroDescription}</p>
                        <button
                            className="hero-button"
                            onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/7', '_blank')}
                        >
                            {t.buttonText}
                        </button>
                    </div>
                </div>

                {/* SECTION 2 */}
                <section className='section py-10'>
                    <p className='section-title'>{t.section2Title}</p>
                    <p className='section-description'>{t.section2Desc}</p>
                </section>

                {/* SECTION 3 */}
                <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
                    <div>
                        <h2 className='section-heading'>{t.whyTitle}</h2>
                        <ul className='benefits-list'>
                            {t.benefits.map((item, idx) => (
                                <li key={idx}>
                                    <strong className='benefit-title'>{item.title}</strong>
                                    <p>{item.desc}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                {/* CTA SECTION */}
                <section className='section'>
                    <div className='cta-box text-center'>
                        <h3 className='cta-title'>{t.ctaTitle}</h3>
                        <p className='cta-description'>{t.ctaDesc}</p>
                        <ul className='cta-benefits'>
                            {[icon1, icon3, icon2, icon4].map((icon, idx) => (
                                <li key={idx} className='cta-lable flex flex-col items-center gap-1 text-center'>
                                    <img src={icon} alt='Check' className='icon' />
                                    {t.ctaBenefits[idx]}
                                </li>
                            ))}
                        </ul>
                        <button
                            className='cta-button mx-auto block'
                            onClick={() => window.open('https://accounts.giv.trade/marketing/links/go/7', '_blank')}
                        >
                            {t.ctaBtn}
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Forex;
